import { Skeleton } from "@/components/skeletons/Skeleton";
import { classNames } from "@/utils/classNames";

export function BigAudioPlayerSkeleton({ bigWaves }: { bigWaves: boolean }) {
  return (
    <div className="flex w-full items-center gap-x-2">
      <div className="block p-1">
        <Skeleton className="h-6 w-6 rounded-lg" />
      </div>
      <Skeleton
        className={classNames(
          "w-full rounded-xl",
          bigWaves ? "h-[80px]" : "h-[40px]"
        )}
      />
    </div>
  );
}
